import React from 'react';
import './view-selected-invoices.scss';
import {
  dispatch,
  getSelectedItems,
  Invoice,
  updateSelectedItemsMap,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { InvoiceCard } from '../invoice-card';
import { CommonButton } from '../../components';
import { useScroll } from '../../hooks';

interface ViewSelectedInvoicesProps {
  bottonText: string;
  onButtonPress: () => void;
  needCount?: boolean;
  showLoading?: boolean;
  isDisable?: boolean;
  showDeletion?: boolean;
  onScroll?: () => void;
}

export const ViewSelectedInvoices: React.FC<ViewSelectedInvoicesProps> = ({
  bottonText = '',
  onButtonPress,
  needCount = true,
  showLoading = false,
  isDisable = false,
  showDeletion = true,
  onScroll = () => {},
}) => {
  const selectedInvoices = useAppSelector(getSelectedItems);

  const { scrollRef, handleTouchStart, handleTouchMove, handleTouchEnd } =
    useScroll();

  return (
    <>
      <div
        className="view-selected-invoice"
        onScroll={onScroll}
        ref={scrollRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {needCount && (
          <div className="view-selected-invoice-header">
            <span className="view-selected-invoice-header-text font-semibold">
              {selectedInvoices?.length
                ? `${selectedInvoices?.length} INVOICES SELECTED`
                : 'NO INVOICES SELECTED'}
            </span>
          </div>
        )}

        <div className="view-selected-invoice-wrapper">
          <div className="view-selected-invoice-wrapper-content">
            {selectedInvoices?.map((invoice: Invoice) => {
              return (
                <InvoiceCard
                  key={invoice.id}
                  invoiceItem={invoice}
                  showDeletion={showDeletion}
                  onDeletePress={() => {
                    dispatch(updateSelectedItemsMap(invoice));
                  }}
                  isDisable={isDisable}
                  showShare={false}
                />
              );
            })}
          </div>
        </div>
      </div>
      {selectedInvoices.length > 0 && (
        <div className="view-selected-invoice-footer">
          <CommonButton
            text={bottonText}
            onPress={onButtonPress}
            loading={showLoading}
            spinnerColor="white"
          />
        </div>
      )}
    </>
  );
};
